(function Module() {
	'use strict';

	mySynch.controller('Notifications', [
		'$scope',
		'MySynchFactory',
		'ApiFactory',
		'$timeout',
		function Notifications($s, MSF, api, $timeout) {
			function updateDisplay() {
				$s.$apply();
			}

			$s.notifications = [];

			$s.$on('message:notification', function anything(scope, messageData) {
				var timeForMessageToLive = +moment.duration(5, 'seconds');
			    var useTimeout = _.get(messageData,'useTimeout',true);
			   
				
                if(useTimeout){
					$timeout(function expireMessage() {
						$s.deleteNotification(messageData);
					}, timeForMessageToLive);
		     	}
				$s.notifications.push(messageData);
				$timeout(updateDisplay, 1);
			});

			$s.deleteNotification = function deleteNotification(notification) {
				$s.notifications = _.without($s.notifications, notification);
			};
		}
	]);
})();
